import heydoctor from 'app/vendor/heydoctor';
import { isEqual } from 'lodash';
import { Stores, Store } from 'app/lib/synaptik';
import * as Analytics from 'app/lib/analytics';

const VIDEO_POLLING_INTERVAL = 2500;

interface State {
  token: string | null;
  videoSession: any;
  fetchOrCreateSession?: boolean;
  getVideoToken?: boolean;
  checkingIsAvailable?: boolean;
  isAvailable?: boolean;
  sendPolling?: boolean;
  enterQueue?: boolean;
  leaveQueue?: boolean;
  notify?: boolean;
  setInReview?: boolean;
}

export class VideoStore extends Store<State, Stores> {
  pollingId: any;

  isPolling = false;

  state: State = {
    token: null,
    videoSession: null,
  };

  startPolling = async () => {
    if (this.pollingId) return;

    this.pollingId = setInterval(() => this.sendPolling(), VIDEO_POLLING_INTERVAL);
  };

  stopPolling = () => {
    clearInterval(this.pollingId);
    this.pollingId = null;
  };

  getVideoToken = async () =>
    this.runAsync({
      key: 'getVideoToken',
      work: async () => {
        const token = await heydoctor.video.getVideoToken();
        this.setState({ token });
        return token;
      },
    });

  checkIsAvailable = async () =>
    this.runAsync({
      key: 'checkingIsAvailable',
      work: async () => {
        const isAvailable = await heydoctor.video.isAvailable();
        this.setState({ isAvailable });
        return isAvailable;
      },
    });

  fetchOrCreateSession = async (visitId: number) =>
    this.runAsync({
      key: 'fetchOrCreateSession',
      work: async () => {
        const videoSession = await heydoctor.video.fetchOrCreateSession(visitId);
        this.setState({ videoSession });
        return videoSession;
      },
    });

  sendPolling = async () =>
    this.runAsync({
      key: 'sendPolling',
      work: async () => {
        if (this.isPolling) return null;

        this.isPolling = true;

        try {
          const videoSession = await this.state.videoSession?.sendHeartbeat();

          if (!isEqual(videoSession, this.state.videoSession)) {
            this.setState({ videoSession: videoSession || {} });
          }

          this.isPolling = false;

          return videoSession;
        } catch (error) {
          this.isPolling = false;
          return null;
        }
      },
    });

  enterQueue = async () =>
    this.runAsync({
      key: 'enterQueue',
      work: async () => {
        const videoSession = await this.state.videoSession?.enterQueue();
        Analytics.onVideoQueueEnter();
        this.setState({ videoSession });
        return videoSession;
      },
    });

  leaveQueue = async () =>
    this.runAsync({
      key: 'leaveQueue',
      work: async () => {
        const videoSession = await this.state.videoSession?.leaveQueue();
        this.setState({ videoSession });
        return videoSession;
      },
    });

  notify = async () =>
    this.runAsync({
      key: 'notify',
      work: async () => {
        const videoSession = await this.state.videoSession?.notify();
        this.setState({ videoSession });
        return videoSession;
      },
    });

  setInReview = async () =>
    this.runAsync({
      key: 'setInReview',
      work: async () => {
        const videoSession = await this.state.videoSession?.setInReview();
        this.setState({ videoSession });
        return videoSession;
      },
    });
}
